export default __webpack_public_path__ + "static/media/start_logo_link-to-new-page.f0c665a4.png";